export enum BrokersState {
    welcome,
    informationClients,
    informationContact,
    finish
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/state/BrokersState.ts